var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useContext, useState } from "react";
import { Button, ListItem } from "@mui/material";
import Chip from "@mui/material/Chip";
import { green } from "@mui/material/colors";
import { deepOrange } from "@mui/material/colors";
import { MechanicShiftContext } from "./MechanicShiftContext";
import { useAsyncAction } from "nate-react-api-helpers";
import { api } from "../../api/API";
import { EndShift } from "./EndShift";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export function MechanicStatus() {
    var _this = this;
    var ctx = useContext(MechanicShiftContext);
    var startShift = useAsyncAction(function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api.tracking.startShift({ startTime: new Date().toISOString() })];
            case 1:
                _a.sent();
                ctx.reload();
                return [2 /*return*/];
        }
    }); }); }, []);
    var _a = useState(false), showEnd = _a[0], setShowEnd = _a[1];
    if (!ctx.validContext)
        return null;
    return /*#__PURE__*/ _jsxs(ListItem, { children: [showEnd && /*#__PURE__*/ _jsx(EndShift, { onClose: function () { setShowEnd(false); } }), /*#__PURE__*/ _jsx("div", { style: { width: "100%" }, children: ctx.current ? /*#__PURE__*/ _jsxs(_Fragment, { children: [/*#__PURE__*/ _jsx(Chip, { style: { backgroundColor: green["800"], color: "white", width: "100%" }, label: "Session Active", size: "small" }), /*#__PURE__*/ _jsx("div", { style: { height: 8 } }), /*#__PURE__*/ _jsx(Button, { variant: "outlined", size: "small", fullWidth: true, onClick: function () { setShowEnd(true); }, children: "End Shift" })] }) : /*#__PURE__*/ _jsxs(_Fragment, { children: [/*#__PURE__*/ _jsx(Chip, { style: { backgroundColor: deepOrange["800"], color: "white", width: "100%" }, label: "Session Inactive", size: "small" }), /*#__PURE__*/ _jsx("div", { style: { height: 8 } }), /*#__PURE__*/ _jsx(Button, { variant: "outlined", size: "small", fullWidth: true, onClick: function () { startShift.callback({}); }, children: "Start Shift" })] }) })] });
}
